import { LOD_SCALES } from "./constants.js";

export function buildMips(heights, size) {
    const mips = [heights];
    let prev = heights;
    let prevSize = size;

    while (mips.length < LOD_SCALES.length) {
        const nextSize = prevSize >> 1;
        const next = new Int16Array(nextSize * nextSize);
        for (let z = 0; z < nextSize; z++) {
            for (let x = 0; x < nextSize; x++) {
                const i = (z * 2) * prevSize + x * 2;
                let max = prev[i];
                const a = prev[i + 1];
                const b = prev[i + prevSize];
                const c = prev[i + prevSize + 1];
                if (a > max) max = a;
                if (b > max) max = b;
                if (c > max) max = c;
                next[z * nextSize + x] = max;
            }
        }
        mips.push(next);
        prev = next;
        prevSize = nextSize;
    }

    return mips;
}

export function updateMipsAt(mips, size, i, j) {
    const heights = mips[0];
    for (let level = 1; level < mips.length; level++) {
        const scale = 1 << level;
        const x = i >> level;
        const z = j >> level;
        const mSize = size >> level;
        const x0 = x << level;
        const z0 = z << level;
        let max = -32768;
        for (let dz = 0; dz < scale; dz++) {
            const row = (z0 + dz) * size;
            for (let dx = 0; dx < scale; dx++) {
                const h = heights[row + x0 + dx];
                if (h > max) max = h;
            }
        }
        mips[level][z * mSize + x] = max;
    }
}

const LEVEL_OF = { 1: 0, 2: 1, 4: 2, 8: 3 };

export function mipHeight(mips, worldSize, i, j, scale, minY) {
    if (i < 0 || j < 0 || i >= worldSize || j >= worldSize) return minY;
    const level = LEVEL_OF[scale];
    const mip = mips[level];
    const mSize = worldSize >> level;
    const x = i >> level;
    const z = j >> level;
    return mip[z * mSize + x];
}
